import * as React from 'react';
import { SVGProps } from 'react';

const SvgTextReminders = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 13.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5zM13.25 17a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0z" />
    <path d="M20 4H4v13.17L5.17 16h8.185a4.772 4.772 0 0 0 0 2H6l-4 4 .01-18c0-1.1.89-2 1.99-2h16c1.1 0 2 .9 2 2v10.437a4.77 4.77 0 0 0-2-1.747V4z" />
    <path d="M14 12H6v2h8v-2zm4-3H6v2h12V9zm0-3H6v2h12V6zm-.992 8.945v2.207l1.646 1.646.707-.707-1.353-1.353v-1.793h-1z" />
  </svg>
);

export default SvgTextReminders;
